import { render, staticRenderFns } from "./Reintegri.vue?vue&type=template&id=5db66c2a&scoped=true"
import script from "./Reintegri.vue?vue&type=script&lang=ts"
export * from "./Reintegri.vue?vue&type=script&lang=ts"
import style0 from "./Reintegri.vue?vue&type=style&index=0&id=5db66c2a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db66c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db66c2a')) {
      api.createRecord('5db66c2a', component.options)
    } else {
      api.reload('5db66c2a', component.options)
    }
    module.hot.accept("./Reintegri.vue?vue&type=template&id=5db66c2a&scoped=true", function () {
      api.rerender('5db66c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Reintegri.vue"
export default component.exports